import { render, staticRenderFns } from "./TagSelectorWithPagination.vue?vue&type=template&id=c3aa1144&scoped=true"
import script from "./TagSelectorWithPagination.vue?vue&type=script&lang=js"
export * from "./TagSelectorWithPagination.vue?vue&type=script&lang=js"
import style0 from "./TagSelectorWithPagination.vue?vue&type=style&index=0&id=c3aa1144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aa1144",
  null
  
)

export default component.exports